import { Component, State, h } from '@stencil/core';
import pin from '../../assets/header/pin.svg';
import arrow from '../../assets/arrow_white.svg';
import { getStoreInformation } from './utils';
import { isBrowser } from '../../constants/constants';

declare global {
  interface Window {
    dataLayer: any;
    aa: any;
  }
}

interface Store {
  name: string;
  address: {
    line1: string;
    line2: string;
    city: string;
    region: string;
    postalCode: string;
  };
  phone: string;
  landingPageUrl: string;
}

@Component({
  tag: 'ci-local-store',
  styleUrl: 'ci-local-store.scss',
  scoped: true,
})
export class CiLocalStore {
  @State() store: Store = null;

  async componentDidLoad() {
    if (isBrowser) {
      const storeInformation = sessionStorage.getItem('storeInformation');
      if (storeInformation !== null) {
        this.store = JSON.parse(storeInformation);
      } else {
        const storeInformation = await getStoreInformation();
        if (storeInformation !== null) {
          this.fireAnalyticsEvent(storeInformation);
          sessionStorage.setItem('storeInformation', JSON.stringify(storeInformation));
        }
        this.store = storeInformation;
      }
    }
  }

  fireAnalyticsEvent = (store: Store) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'local_store',
      location: `${store.address.city}, ${store.address.region}`,
    });
    return;
  };

  storesDropdown = () => {
    const { line1, line2, city, region, postalCode } = this.store.address;
    return (
      <div class="ghf-localStore ghf-localStore--desktop">
        <img src={pin} alt="pin icon" />
        <span>
          Visit Your Store:{' '}
          <span class="ghf-localStore-hover">
            <u>{this.store.name}</u>
          </span>
        </span>
        <img src={arrow} alt="arrow down - white" />
        <aside id="localStore-tooltip" class="ghf-localStore-tooltip">
          <span class="ghf-localStore-tooltip-address">
            {line1} <br />
            {line2 && (
              <span>
                {line2} <br />
              </span>
            )}
            {city}, {region} {postalCode}
          </span>
          <div class="ghf-localStore-tooltip-actions">
            <a href={`tel:${this.store.phone}`}>{this.store.phone}</a>
            <a href="https://locations.customink.com">Change Store</a>
            <a href={this.store.landingPageUrl}>Book an appointment</a>
          </div>
        </aside>
      </div>
    );
  };

  render() {
    return (
      <div>
        <a class="ghf-localStore ghf-localStore--mobile" href="https://locations.customink.com/">
          <img src={pin} alt="pin icon" />
          Stores
        </a>
        {this.store !== null ? this.storesDropdown() : ''}
      </div>
    );
  }
}
